// extracted by mini-css-extract-plugin
export default {"dashboard":"ProjectDashboard_dashboard__Ku+TI"};